export default __webpack_public_path__ + "maps-examples-default-styles-thumbnail-480-cc374a6d801604e68fc87c396fafed5c.webp";